import { gql } from '@apollo/client';

const CITIESMODAL = gql`
  query CITIESMODAL {
    findYourCity: citiesPage {
      cities: all_cities {
        city {
          id
          name
          slug
          card_media {
            name
            alt: alternativeText
            url
          }
        }
      }
    }
  }
`;
export default CITIESMODAL;
